export const isPasswordValid = (value) => {
  if (
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*&])[A-Za-z\d@$!%*&]{12,}$/.test(
      value
    )
  )
    return true;
  else return false;
};
